<script>
import {renderHeader} from './utils'

export default {
  name: 'CardSection',
  props: {
    title: {
      type: String
    },
    subdued: {
      type: Boolean
    },
    actions: {
      type: Array
    },
    padded: {
      type: Boolean,
      default: true
    }
  },
  functional: true,
  render(h, {props, data, children, $style}) {
    const header = renderHeader(h, props, $style)
    return h('div', {
      class: [
        'UIElement',
        data.staticClass,
        data.class,
        $style.CardSection,
        props.subdued && $style.subdued,
        header && $style.CardSection__header,
        !props.padded && $style.CardSection__noPadding
      ],
      attrs: {
        'data-card-section': true
      }
    }, [
      header,
      children
    ])
  }
}
</script>

<style lang="scss" module>
@import "../../styles/variables";

$padding: $s4;

.CardSection {
  padding: $padding;
}

.CardSection + .CardSection {
  border-top: 1px solid #e7e9ec;
}

.header {
  display: flex;
  align-items: center;
}

.actions {
  margin-left: auto;
}

.action + .action {
  margin-left: 4px;
}

.title {
  flex: 1 1 auto;
  margin-bottom: 12px;
  color: #212b36;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
}

.subdued {
  background: #f9fafb;
}

.CardSection__noPadding {
  padding: $padding 0;

  .header {
    padding: $padding;
    padding-bottom: 0;
  }

  .title {
    margin-bottom: 0;
  }

  &.CardSection__header {
    padding-top: 0;
  }
}
</style>
